module.exports = __webpack_public_path__ + "fonts/Neboma_Sporte.4c1d12a6.woff";